(function () {
  var key = 'fabrecia:recently-viewed';
  function read() {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(key, JSON.stringify(items.slice(0, 12))); } catch (e) {}
  }
  if (window.FabreciaProduct && window.FabreciaProduct.current) {
    var current = window.FabreciaProduct.current;
    var items = read().filter(function (item) { return item.handle !== current.handle; });
    items.unshift(current);
    write(items);
  }
  document.querySelectorAll('[data-recently-viewed-grid]').forEach(function (grid) {
    var items = read().filter(function (item) { return !(window.FabreciaProduct && window.FabreciaProduct.current && item.handle === window.FabreciaProduct.current.handle); }).slice(0, 8);
    grid.innerHTML = items.map(function (item) {
      return '<article class="product-card"><div class="product-card__media product-card__media--portrait"><a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy"></a></div><div class="product-card__body"><h3 class="product-card__title"><a href="' + item.url + '">' + item.title + '</a></h3><div class="price"><span>' + item.price + '</span></div></div></article>';
    }).join('');
  });
})();
